import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button";
import { Heading } from "components/Heading";
import { Container } from "components/Layout/Container";
import { AnalyticsEventType, useAnalyticsEvent } from "components/utils/analytics";
import { HeadingLevel } from "types/HeadingLevel";
import cn from "classnames";
import useMediaQuery from "components/utils/useMediaQuery";

export const UnauthorizedPage: React.FC<React.HTMLAttributes<HTMLDivElement>> = () => {
    useAnalyticsEvent(AnalyticsEventType.UNAUTHORIZED, { path: document.location.pathname });
    const isMobile = useMediaQuery("(max-width: 768px)");

    return (
        <Container style={{ maxWidth: "520px" }} className="align-middle text-center pt-5">
            <FontAwesomeIcon
                icon={["far", "triangle-exclamation"]}
                className="fs-1 p-3 text-secondary border border-secondary rounded-circle mb-3"
            />
            <Heading level={HeadingLevel.H1} className={cn("fw-bold", { "fs-3": !isMobile })}>
                Page Not Available
            </Heading>
            <p className="fs-5 pt-2 pb-4 mb-0 text-wrap">
                We're sorry, but the page you're looking for is not available. Try checking the URL, or return to the homepage.
            </p>
            <Button className="p-2" href="/" target="_self" variant="primary" text="Return Home" />
        </Container>
    );
};
